import { useMemo } from "react";
import { img } from "../lib/api";
import { useApp } from "../context/AppContext";

import { tx, useLang } from "../lib/i18n";
const PARTICLES = Array.from({ length: 22 }, (_, i) => ({
  left: (i * 37) % 100, top: (i * 53 + 11) % 92, d: 5 + (i % 6), dl: (i * 0.7) % 6, s: i % 3 === 0 ? 4 : 2,
}));

const Orbit = () => { useLang(); return (
  <svg className="hero-orbit" viewBox="0 0 1000 660" preserveAspectRatio="none" aria-hidden="true">
    <defs>
      <linearGradient id="orbitGrad" x1="0" x2="1" y1="0" y2="0">
        <stop offset="0%" stopColor="#00E5BC" stopOpacity="0" />
        <stop offset="45%" stopColor="#00E5BC" stopOpacity="0.55" />
        <stop offset="100%" stopColor="#00E5BC" stopOpacity="0.05" />
      </linearGradient>
      <filter id="orbitBlur" x="-20%" y="-20%" width="140%" height="140%"><feGaussianBlur stdDeviation="6" /></filter>
      <filter id="orbitBlurSm"><feGaussianBlur stdDeviation="1.6" /></filter>
    </defs>
    <g transform="rotate(-14 500 360)" className="orbit-pulse">
      <ellipse cx="500" cy="380" rx="430" ry="150" fill="none" stroke="url(#orbitGrad)" strokeWidth="1.4" opacity="0.6" />
      <ellipse cx="500" cy="380" rx="430" ry="150" fill="none" stroke="#00E5BC" strokeWidth="10" opacity="0.18" filter="url(#orbitBlur)" />
      <ellipse className="orbit-trail" cx="500" cy="380" rx="430" ry="150" fill="none" stroke="#7DFBE4" strokeWidth="3.5" strokeLinecap="round"
        pathLength="1000" strokeDasharray="210 790" filter="url(#orbitBlurSm)" />
    </g>
    <g transform="rotate(8 520 300)">
      <ellipse className="orbit-trail-2" cx="520" cy="300" rx="300" ry="215" fill="none" stroke="#00E5BC" strokeWidth="1.6" strokeLinecap="round"
        pathLength="1000" strokeDasharray="120 880" opacity="0.55" filter="url(#orbitBlurSm)" />
    </g>
  </svg>
); };

const FloatingObject = ({ o, index, edit }) => { useLang();
  const style = { "--x": o.x, "--y": o.y, "--w": o.width, zIndex: o.depth };
  const vars = { "--dur": `${o.duration}s`, "--delay": `${o.delay}s`, "--amp": `${o.amplitude}px`, "--tilt": `${o.tilt}deg` };
  const held = edit?.held === o.object_id;
  return (
    <div className={`hero-obj ${index >= 5 ? "mobile-hide" : ""} ${edit ? "hero-obj-edit" : ""} ${edit?.selected === o.object_id ? "is-selected" : ""} ${held ? "is-held" : ""}`} style={style}
      data-testid={`hero-floating-object-${index}`} aria-hidden={edit ? undefined : "true"} onPointerDown={edit ? (e) => edit.start(e, o, "move") : undefined}>
      {edit && edit.selected === o.object_id && ["nw", "ne", "sw", "se"].map((c) => (
        <span key={c} className={`hero-handle hero-handle-${c}`} onPointerDown={(e) => { e.stopPropagation(); edit.start(e, o, c); }} data-testid={`hero-resize-${c}-${index}`} />
      ))}
      {held && <span className="hero-pos-label" data-testid="hero-drag-readout">X {o.x} · Y {o.y} · W {o.width}</span>}
      <div className="drift" style={vars}>
        <div className="float" style={vars}>
          <img src={img(o.image)} alt="" draggable="false" loading={index < 4 ? "eager" : "lazy"} decoding="async"
            onError={(e) => { e.currentTarget.closest(".hero-obj").style.display = "none"; }} />
        </div>
      </div>
    </div>
  );
};

export const HeroOrbit = ({ objects = [], enabled = true, edit = null }) => { useLang();
  const { motion, paused } = useApp();
  const objs = useMemo(() => objects.filter((o) => o.enabled).slice(0, 12), [objects]);
  return (
    <div className="hero-art" data-testid="hero-orbit-scene" data-motion={enabled ? motion : "off"} data-paused={paused ? "true" : "false"}>
      <div className="hero-bg-glow" />
      {PARTICLES.map((p, i) => (
        <span key={i} className="hero-particle" style={{ left: `${p.left}%`, top: `${p.top}%`, width: p.s, height: p.s, "--pd": `${p.d}s`, "--pdl": `-${p.dl}s` }} />
      ))}
      <Orbit />
      {edit?.guides?.v && <span className="hero-guide hero-guide-v" data-testid="hero-guide-v" />}
      {edit?.guides?.h && <span className="hero-guide hero-guide-h" data-testid="hero-guide-h" />}
      {objs.map((o, i) => <FloatingObject key={o.object_id || i} o={o} index={i} edit={edit} />)}
    </div>
  );
};
